import type { AnchorsExportModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import { toast } from 'sonner'

import { client } from '@/shared/api/client'
import { download, getFileNameFromResponse } from '@/shared/tools/report'

export const downloadAssortmentFile = (
	body: AnchorsExportModel,
	name: string,
	t: TFunction
) => {
	toast.loading(t('report_file_loading'), { id: 'export' })

	return client.instance
		.post('/api/v1/anchors/export', body, { responseType: 'blob' })
		.then((response) => {
			download(
				new Blob([response.data]),
				name ?? getFileNameFromResponse(response)
			)
			toast.success('Success', { id: 'export' })
		})
		.catch(() => {
			toast.error('Downloading failed, please try again.', { id: 'export' })
		})
}
